import React, { useEffect, useState } from 'react'
import Input from '../../ui/forms/Input';
import { IoClose } from 'react-icons/io5';
import Checkbox from '../../ui/forms/Checkbox';
import Button from '../../ui/comp/Button';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Axios } from '../../utils/Axios';
import { useSearchParams } from 'react-router-dom';
import { formatDateForInput } from '../../utils/config';

function UpdateCoupon({ onClose }) {
    const [data, setdata] = useState({
        code: "",
        discount: "",
        end: "",
        minimum: 0,
        active: true
    })

    const queryClient = useQueryClient()
    const [searchParams] = useSearchParams()

    const { data: coupons } = useQuery({
        queryKey: ['coupon2'],
        queryFn: async () => {
            const res = await Axios.get(`/coupon/get?id=${searchParams.get('coupon')}`)
            return res.data
        }
    })


    useEffect(() => { setdata(coupons) }, [coupons])


    // Update Mutate

    const { mutate, isPending, error, isError, isSuccess } = useMutation({
        mutationFn: async (formData) => {
            const res = await Axios.post('/coupon/update', formData);
            return res.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['coupons'])
        }
    })

    // Onchange Handdle

    const handleInputs = (e) => {
        const { id, value } = e.target
        setdata({ ...data, [id]: value })
    }

    const addCoupon = (e) => {
        e.preventDefault()
        const formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })

        mutate(formData)
    }

    if (isSuccess) {
        onClose()
    }


    return (
        <div className='fixed w-full h-full top-0 left-0 z-[99999] flex justify-center items-center p-5'>

            <div onClick={() => onClose()} className='absolute top-0 left-0 w-full h-full bg-black/40' />

            {/* Contents */}
            <div className="max-w-3xl w-full relative z-50 bg-white rounded-xl p-4">

                {/* Head */}
                <div className="pb-2 flex items-center w-full justify-between border-b">
                    <p className="">Update Coupon</p>
                    <button onClick={() => onClose()}><IoClose /></button>
                </div>

                <div className="mt-5 mx-auto max-w-xl pb-7 space-y-3">
                    <div className="flex flex-col gap-3">
                        <Input placeholder="Coupon Code eg: ECSBLACKFRIDAY" value={data?.code} id='code' onChange={handleInputs} />
                        <Input type='datetime-local' value={formatDateForInput(data?.end)} id='end' onChange={handleInputs} />
                        <Input placeholder="Discount %" value={data?.discount} id='discount' onChange={handleInputs} />
                        <Input placeholder="Minimum Amount" value={data?.minimum} id='minimum' onChange={handleInputs} />
                        <Checkbox label={"Active"} checked={data?.active} onChange={(e) => setdata({ ...data, active: e.target.checked })} />
                    </div>
                    <Button onClick={addCoupon} loading={isPending} fullWidth={true}>Update Coupon</Button>
                    {isError && (
                        <div className="text-red-500 text-sm capitalize text-center">{error?.response?.data || "Unknown"}</div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default UpdateCoupon